import { ExperimentStore } from 'bernie-plugin-mobx';

import { getBucketValueByExperimentName } from 'utility';

const EXPERIMENT_NAME = 'EGTNL_Air_Smart_Shopping';
const FLIGHT_CARD_EXPERIMENT = 'Air_Smart_Shopping_Web_Flight_Card_TnL';

export const airSmartShopping = {
  shouldRender: (experiment: ExperimentStore): boolean => {
    return getBucketValueByExperimentName(experiment, EXPERIMENT_NAME) === 1;
  }
};

export const webFlightCardTnL = {
  shouldRender: (experiment: ExperimentStore): boolean => {
    return getBucketValueByExperimentName(experiment, FLIGHT_CARD_EXPERIMENT) === 1;
  }
};
